import Tabs from '@/components/ui/tabs';
import { useSurveyDashboardStore } from '../../store/useSurveyDashboard.store';

export const SurveyDashboardTabs = () => {
  const { currentTab, uploadCurrentTab, page } = useSurveyDashboardStore((store) => {
    return {
      currentTab: store.currentTab,
      uploadCurrentTab: store.uploadCurrentTab,
      page: store.page,
    };
  });
  const tabs = [
    {
      name: page?.tabs.surveyResponses || '',
      current: currentTab === 'survey-responses',
      onClick: () => {
        uploadCurrentTab('survey-responses');
      },
    },
    {
      name: page?.tabs.responseTable || '',
      current: currentTab == 'response-table',
      onClick: () => {
        uploadCurrentTab('response-table');
      },
    },
  ];

  return (
    <div className=" flex w-full justify-center">
      <Tabs tabs={tabs} setTabs={() => {}} enableEmptyOnClick selectClassNames="!mt-0" />
    </div>
  );
};
